<template>
  <main class="importMobile container-fluid mf_container pb_50 mb_50">
    <div v-show="is_ready">
      <h4 class="text-green mt_22">匯入行動投保</h4>
      <div class="mt_17">
        <strong>{{ (this.isIV ? "" : "選擇要") + "匯入的建議" }}</strong>
      </div>
      <!-- 可選投資型報表 -->
      <OperateContractItemIV
        @isReady="updateReady"
        v-if="!isLoading && isIV"
        :contractData="proposal"
      ></OperateContractItemIV>
      <!-- 可選傳統型報表 -->
      <OperateContractItemTD
        @isReady="updateReady"
        v-else-if="!isLoading"
        selectedMode="checkbox"
        :contractData="proposal"
        @updateMCProdList="handleUpdate"
      ></OperateContractItemTD>
      <!-- 可選報表 -->
      <FixedBottom>
        <template slot="@function">
          <div class="d-flex justify-content-end mr_15">
            <router-link
              class="btn btn-default px_5 mr_10"
              to="/mf/query/queryDetail"
              >查詢其他建議書</router-link
            >
            <button
              v-if="!isIV"
              @click="toImportMobile()"
              class="btn btn-primary px_5 mr_10"
              type="button"
              :disabled="!is_selected || waiting"
            >
              確定匯入
            </button>
          </div>
        </template>
      </FixedBottom>
    </div>
    <MfLoading :open="!is_ready && !isIV" content="資料讀取中..." />
    <MfLoading :open="waiting" content="資料匯入中..." />
    <!-- AG操作前台-匯入行動投保 資料比對POP提醒  -->
    <template>
      <div
        id="importMobileAGModal"
        class="modal fade confirm importMobileAGModal"
        :class="{ 'is-open': importMobileModalOpen }"
      >
        <div class="modal-dialog" style="width: 500px">
          <div class="modal-content">
            <div class="modal-header">
              <a @click.stop="importMobileModalOpen = false" class="close">
                <i class="icon-close"></i>
              </a>
              <h3 class="modal-title pl-0" style="font-size: 20px">
                請再次確認客戶資料
              </h3>
            </div>
            <div class="modal-body px_0 py_0 text-sm">
              <section class="pb_10 pt_10 pr_10 pl_10 mf-textWrap text-start">
                {{ customerData.message }}
              </section>
              <!-- 確定按鈕 -->
              <section class="d-flex justify-content-around pb_10">
                <div class="action text-right">
                  <button
                    type="submit"
                    class="btn btn-default"
                    @click.prevent="routeToCustDetail"
                  >
                    回CRM更新客戶資料
                  </button>
                  <button
                    type="submit"
                    class="btn btn-default"
                    @click.stop="ensureImportMI()"
                  >
                    確認無誤，直接匯入MI
                  </button>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </template>
  </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import mf_Mixin from "@/desktop/views/mf/mixin";
import MfLoading from "@/desktop/views/mf/components/MfLoading";
import FixedBottom from "@/desktop/views/mf/components/fixedBotton";
import OperateContractItemIV from "@/desktop/views/mf/components/OperateContractItem_IV.vue";
import OperateContractItemTD from "@/desktop/views/mf/components/OperateContractItem_TD.vue";
import { getCustInfo } from "@/service";

export default {
  mixins: [mf_Mixin],
  components: {
    MfLoading,
    OperateContractItemTD,
    OperateContractItemIV,
    FixedBottom,
  },
  data() {
    return {
      proposal: {},
      proposalListScope: [],
      waiting: false,
      no_mi_list: [],
      isLoading: true,
      is_selected: true,
      is_ready: false,
      importMobileModalOpen: false,
      customerData: {
        message: "",
        id: "",
      },
    };
  },
  computed: {
    ...mapGetters(["CustInfo", "UserInfo", "MfViewing"]),
    isIV() {
      return this.MfViewing.saveData.prod_type != "1";
    },
  },
  async created() {
    if (!this.MfViewing.prod_idx) {
      return this.$router.push("/mf/query");
    }
    this.updateClickDate();
    //載入不可匯入行動投保列表
    if (this.$store.getters.IsBankUser) {
      this.no_mi_list = this.$special_array("no_bk_mi");
    } else {
      this.no_mi_list = this.$special_array("no_mi");
    }

    if (!this.isIV) {
      //傳統型呼叫
      let res_TD = await this.$mfAPI.MFA0_1000__queryProposalDetailList({
        agent_id: this.$store.state.userInfo.id,
        insured_id: "",
        prod_idx: this.MfViewing.saveData.prod_idx,
      });
      this.proposal = res_TD.proposal[0];
      this.isLoading = false;
      this.proposalListScope = this.proposal.mc_prod_list;
    } else {
      this.waiting = true;
      //投資型
      let res_IV = await this.$mfAPI.MFA1_1000__queryProposalDetailList({
        agent_id: this.$store.state.userInfo.id,
        insured_id: "",
        prod_idx: this.MfViewing.saveData.prod_idx,
      });
      this.proposal = res_IV.proposal[0];
      this.proposalListScope = this.proposal.mc_prod_list;
      await this.toImportMobile(); //投資型自動匯入
      this.isLoading = false; //匯入完成後才顯示畫面
    }
  },
  methods: {
    ...mapActions(["updateCustID", "updateSerNo"]),
    //連至客戶個人資訊
    routeToCustDetail() {
      this.importMobileModalOpen = false;
      // 此頁覆寫了 MF mixin 的同名方法，因此需自行支援 MXF1 回傳母頁流程。
      if (this.postMxf1Customer(this.customerData.id)) return;

      // 非 MXF1 維持既有 ID/serNo 分流與 CRMVUE 客戶詳情頁導頁。
      let isSerNo = this.customerData.id.startsWith("~");
      let custId = isSerNo ? "" : this.customerData.id;
      let serId = isSerNo ? this.customerData.id : "";
      this.updateCustID(custId);
      this.updateSerNo(serId);
      localStorage.CustID = custId;
      localStorage.SerNo = serId;
      this.$router.push({ path: `/detail/CustID/tab/1` });
    },
    async toImportMobile() {
      this.$mfAPI
        .MFA0_2100__checkCustomerBasicData({
          proposalMap: {
            insured_gender: this.proposal.insured_gender,
            insurer_birthday: this.proposal.insurer_birthday,
            insurer_name: this.proposal.insurer_name,
            insurer_gender: this.proposal.insurer_gender,
            insured_name: this.proposal.insured_name,
            insurer_id: this.proposal.insurer_id,
            insured_birthday: this.proposal.insured_birthday,
            insured_id: this.proposal.insured_id,
          },
        })
        .then(async (res) => {
          if (res.message !== "") {
            this.customerData.message = res.message;
            this.customerData.id = res.id;
            this.importMobileModalOpen = true; //打開POP
          } else {
            this.ensureImportMI();
          }
        })
        .catch((error) => {
          console.log("-------error--------", error);
        });
    },
    async ensureImportMI() {
      this.importMobileModalOpen = false;
      this.waiting = true;
      let toImportList;
      this.isIV
        ? (toImportList = this.proposalListScope)
        : (toImportList = this.proposalListScope.filter((item) => {
            return item.is_checked;
          }));
      if (!this.isIV && toImportList.length < 1) {
        this.$toast.info({ title: `請先勾選建議!` });
        this.waiting = false;
      }
      ////----------第一步，檢核證照卡控--------------////
      let canUse = true;
      let hasQualificationObj = await this.inquireQualificationByKind4CSR(
        toImportList,
      );
      canUse = hasQualificationObj.hasQualification;
      //證照檢核不通過
      if (!canUse) {
        return (this.waiting = false);
      }
      ////----------第二步，不可使用MI商品--------------////
      // let canUse = false;
      toImportList.forEach((mc) => {
        if (this.no_mi_list.includes(mc.prod_id)) {
          this.$toast.info({
            title: `${mc.prod_name}(${mc.prod_id})無法使用本功能!`,
          });
          canUse = false;
        }
      });
      //不可使用MI商品 不通過
      if (!canUse) {
        return (this.waiting = false);
      }
      ////----------第三步，檢核要被保人是否有身分證--------------////
      let errorArray = ["", "", ""];
      if (this.proposal.insurer_id.indexOf("~") > -1) {
        errorArray[0] = "匯入失敗! 要保人身分證字號未輸入故無法使用本功能!";
      }
      if (this.proposal.insured_id.indexOf("~") > -1) {
        errorArray[1] = "匯入失敗! 主約被保人身分證字號未輸入故無法使用本功能!";
      }
      this.proposal.mc_prod_list.forEach((mc) => {
        mc.sc_prod_list.forEach((sc) => {
          if (sc.insured_id.indexOf("~") > -1) {
            errorArray[2] =
              "匯入失敗! 附約被保人身分證字號未輸入故無法使用本功能!";
            return;
          }
        });
      });
      if (errorArray.join("") != "") {
        errorArray[0] &&
          this.$toast.info({
            title: `${errorArray[0]}`,
          });
        errorArray[1] &&
          this.$toast.info({
            title: `${errorArray[1]}`,
          });
        errorArray[2] &&
          this.$toast.info({
            title: `${errorArray[2]}`,
          });

        return (this.waiting = false);
      }
      ////----------第四步，檢核日額通算--------------////
      let checkDailyCalculateRes = await this.checkDailyCalculate({
        insured_age: this.proposal.insured_age,
        mc_prod_list: toImportList,
      });
      if (!checkDailyCalculateRes) return;
      ////----------檢核通過，開始執行匯入--------------////
      //合成家戶CRMList
      let CRMListObj = {};
      if (!CRMListObj[this.proposal.insured_id]) {
        let result = await getCustInfo(
          this.$store.state.userInfo.id,
          this.$store.state.userInfo.id,
          this.proposal.insured_id,
        );
        this.checkCustInfoResult(
          //保代無客戶資料，將基本資料補進去
          result,
          this.proposal.insured_id,
          this.proposal.insured_birthday,
          this.proposal.insured_age,
          this.proposal.insured_name,
          this.proposal.insured_gender,
        );
        result.body.customer.actage = result.body.customer.birthday
          ? moment().diff(moment(result.body.customer.birthday), "years")
          : result.body.customer.age;
        CRMListObj[this.proposal.insured_id] = result.body;
      }
      if (!CRMListObj[this.proposal.insurer_id]) {
        let result = await getCustInfo(
          this.$store.state.userInfo.id,
          this.$store.state.userInfo.id,
          this.proposal.insurer_id,
        );
        this.checkCustInfoResult(
          //保代無客戶資料，將基本資料補進去
          result,
          this.proposal.insurer_id,
          this.proposal.insurer_birthday,
          this.proposal.insurer_age,
          this.proposal.insurer_name,
          this.proposal.insurer_gender,
        );
        result.body.customer.actage = result.body.customer.birthday
          ? moment().diff(moment(result.body.customer.birthday), "years")
          : result.body.customer.age;
        CRMListObj[this.proposal.insurer_id] = result.body;
      }
      for (let i = 0; i < toImportList.length; i++) {
        let mc = toImportList[i];
        for (let j = 0; j < mc.sc_prod_list.length; j++) {
          let sc = mc.sc_prod_list[j];
          if (!CRMListObj[sc.insured_id]) {
            let result = await getCustInfo(
              this.$store.state.userInfo.id,
              this.$store.state.userInfo.id,
              sc.insured_id,
            );
            this.checkCustInfoResult(
              //保代無客戶資料，將基本資料補進去
              result,
              sc.insured_id,
              sc.insured_birthday,
              sc.insured_age,
              sc.insured_name,
              sc.insured_gender,
            );
            result.body.customer.actage = result.body.customer.birthday
              ? moment().diff(moment(result.body.customer.birthday), "years")
              : result.body.customer.age;
            CRMListObj[sc.insured_id] = result.body;
          }
        }
      }
      let CRMList = [];
      for (let key in CRMListObj) {
        CRMList.push(CRMListObj[key]);
      }

      // 發送匯入API
      this.$mfAPI
        .MFA0_2100__importMI({
          proposalMap: {
            ...this.proposal,
            mc_prod_list: toImportList,
            channel_type: this.$store.getters.UserChannelType,
          },
          CRMList,
        })
        .then((res) => {
          this.waiting = false;
          this.$toast.info({
            title: `匯入成功! 請開啟行動投保APP繼續後續作業!`,
          });
        })
        .catch((message) => {
          // this.$toast.info({ title: message });
          this.$toast.info({
            title: "匯入行動投保失敗! 請確認客戶電話及地址格式是否有誤。",
          });
          this.waiting = false;
        });
    },
    checkCustInfoResult(result, id, birthday, age, name, sex) {
      let customer = result.body.customer;
      if (!customer.id) {
        customer.id = id;
      }
      if (!customer.birthday) {
        customer.birthday = birthday;
      }
      if (!customer.age) {
        customer.age = age;
      }
      if (!customer.name) {
        customer.name = name;
      }
      if (!customer.sex) {
        customer.sex = sex;
      }
    },
    handleUpdate(mc_prod_list) {
      this.proposalListScope = mc_prod_list;
      this.is_selected = false;
      this.proposalListScope.forEach((mc) => {
        if (mc.is_checked) {
          this.is_selected = true;
          return;
        }
        mc.sc_prod_list.forEach((sc) => {
          if (sc.is_checked) {
            this.is_selected = true;
          }
        });
      });
    },
    updateReady() {
      this.is_ready = true;
    },
  },
};
</script>
<style lang="scss">
.importMobile {
  color: #323a45;
  @media (min-width: 1025px) {
    width: 100%;
    max-width: 1280px;
  }
  &__proposalList {
    padding: 20px 0;
    &__item {
      display: flex;
      align-items: flex-start;
      border-bottom: solid 1px #e0e1e3;
    }
    .checkbox input + label:before {
      margin: 0;
    }
  }
}
</style>
